/* eslint-disable */
import React, { useState } from "react";
import { Mail, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Persistent banner shown to unverified accounts only.
 * Disappears permanently once user.is_verified is true.
 */
export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);

  if (!user || user.is_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      if (data.already_verified) {
        toast.success("Email already verified");
      } else {
        toast.success("Verification email re-sent — check the server console for the link.");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not resend verification email.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="rounded-md border border-[var(--rg-amber)] bg-[var(--rg-amber-soft)] px-4 py-3 mb-6 flex items-start gap-3"
      data-testid="verify-email-banner"
    >
      <Mail className="w-5 h-5 text-[var(--rg-amber)] mt-0.5 shrink-0" />
      <div className="flex-1 text-sm">
        <div className="text-[var(--rg-text-strong)] font-semibold">
          Please verify your email address to run your first audit.
        </div>
        <div className="text-[var(--rg-text)] mt-0.5">
          Check your inbox for the verification email.
        </div>
        <button
          type="button"
          onClick={resend}
          disabled={sending}
          className="mt-1.5 text-[var(--rg-amber)] hover:text-[var(--rg-amber)] underline text-xs font-semibold disabled:opacity-60"
          data-testid="resend-verification-btn"
        >
          {sending ? "Sending…" : "Resend verification email"}
        </button>
      </div>
    </div>
  );
}
